import {
  Card,
  Grid,
  Stack,
  Typography,
  Container,
  Divider,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Box,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { getInvoicedDetailedAction } from './Action';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GetDownloadFileAction } from '../../screen/distributor/action/util_action';

const InvoiceDetailed = () => {
  const { id } = useParams();
  const [invoiceData, setInvoiceData] = useState({});

  const getInvoiceDetails = async () => {
    const { data, error, message } = await getInvoicedDetailedAction({
      invoice_id: id,
    });

    if (!error) {
      setInvoiceData(data);
    } else {
      return toast.error(message);
    }
  };
  useEffect(() => {
    getInvoiceDetails();
  }, []);
  const invoiceFileType = {
    invoice: 'invoice',
    test_certificate: 'test_certificate',
  };
  const downloadHandler = async (fileType, invoiceDetails) => {
    const files = invoiceDetails.filter((item) => item.file_type === fileType);

    if (files.length <= 0) {
      return toast.error(
        `No ${
          invoiceFileType['invoice'] === fileType
            ? 'Invoice Files'
            : 'Test Certificates'
        } Available`,
      );
    }

    files.map(
      async (item) =>
        await GetDownloadFileAction(
          item.invoice_file_id,
          item.filename,
          item.file_type,
        ),
    );
  };

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: 'rgba(245,245,245,.6)',
        }}
      >
        <Card sx={{ p: '2rem' }}>
          <Typography variant='h4'>Invoice Details</Typography>
          <Divider sx={{ mt: '1rem', mb: '3rem' }} />
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={6}
            >
              <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'space-between'}
                sx={{ pr: '3rem' }}
              >
                <Typography
                  variant='h6'
                  fontWeight={'550'}
                  fontSize={16}
                >
                  Invoice Number:
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={'500'}
                  fontSize={16}
                >
                  {invoiceData?.invoice_details?.invoice_no}
                </Typography>
              </Stack>
              <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'space-between'}
                sx={{ pr: '3rem' }}
              >
                <Typography
                  variant='h6'
                  fontWeight={'550'}
                  fontSize={16}
                >
                  Date Of Invoice:
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={'500'}
                  fontSize={16}
                >
                  {invoiceData?.invoice_details?.date_of_invoice}
                </Typography>
              </Stack>
              <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'space-between'}
                sx={{ pr: '3rem' }}
              >
                <Typography
                  variant='h6'
                  fontWeight={'550'}
                  fontSize={16}
                >
                  Ship To Party
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={'500'}
                  fontSize={16}
                >
                  {invoiceData?.invoice_details?.company_name}
                </Typography>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'space-between'}
                sx={{ pr: '3rem' }}
              >
                <Typography
                  variant='h6'
                  fontWeight={'550'}
                  fontSize={16}
                >
                  Manufacturer Name
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={'500'}
                  fontSize={16}
                >
                  {invoiceData?.invoice_details?.buy_or_sell_to_company_name}
                </Typography>
              </Stack>
              <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'space-between'}
                sx={{ pr: '3rem' }}
              >
                <Typography
                  variant='h6'
                  fontWeight={'550'}
                  fontSize={16}
                >
                  Order Id :
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={'500'}
                  fontSize={16}
                >
                  {invoiceData?.invoice_details?.order_id}
                </Typography>
              </Stack>
              {invoiceData?.total_info?.quantity && (
                <Stack
                  spacing={2}
                  direction={'row'}
                  justifyContent={'space-between'}
                  sx={{ pr: '3rem' }}
                >
                  <Typography
                    variant='h6'
                    fontWeight={'550'}
                    fontSize={16}
                  >
                    Invoiced Quantity
                  </Typography>
                  <Typography
                    variant='h6'
                    fontWeight={'500'}
                    fontSize={16}
                  >
                    {invoiceData?.total_info?.quantity}
                  </Typography>
                </Stack>
              )}
              {invoiceData?.total_info?.amount && (
                <Stack
                  spacing={2}
                  direction={'row'}
                  justifyContent={'space-between'}
                  sx={{ pr: '3rem' }}
                >
                  <Typography
                    variant='h6'
                    fontWeight={'550'}
                    fontSize={16}
                  >
                    Invoiced Amount
                  </Typography>
                  <Typography
                    variant='h6'
                    fontWeight={'500'}
                    fontSize={16}
                  >
                    {invoiceData?.total_info?.amount}
                  </Typography>
                </Stack>
              )}
            </Grid>
          </Grid>
        </Card>
        <Card sx={{ p: '2rem', mt: '2rem' }}>
          <Stack
            direction={'row'}
            justifyContent={'space-between'}
          >
            <Typography variant='h6'>Invoiced Product Details</Typography>
            {invoiceData?.invoice_details?.invoice_file_details?.length > 0 && (
              <Stack
                direction={'row'}
                spacing={4}
                justifyContent={'flex-end'}
              >
                <Button
                  onClick={() =>
                    downloadHandler(
                      invoiceFileType['invoice'],
                      invoiceData?.invoice_details?.invoice_file_details,
                    )
                  }
                  variant='outlined'
                  sx={{
                    height: 30,
                  }}
                >
                  Download Invoice
                </Button>

                <Button
                  onClick={() =>
                    downloadHandler(
                      invoiceFileType['test_certificate'],
                      invoiceData?.invoice_details?.invoice_file_details,
                    )
                  }
                  variant='outlined'
                  sx={{
                    height: 30,
                  }}
                >
                  Download Test Certificates
                </Button>
              </Stack>
            )}
          </Stack>
          <Divider sx={{ mt: '1rem', mb: '3rem' }} />

          <TableContainer>
            <Table aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell
                    align='center'
                    sx={{ fontWeight: 'bold' }}
                  >
                    Product Name
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ fontWeight: 'bold' }}
                  >
                    U.O.M
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ fontWeight: 'bold' }}
                  >
                    Quantity
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ fontWeight: 'bold' }}
                  >
                    GST %
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ fontWeight: 'bold' }}
                  >
                    U.O.M Ex GST Price
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ fontWeight: 'bold' }}
                  >
                    Additional Discount(U.O.M Wise)
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ fontWeight: 'bold' }}
                  >
                    U.O.M Net Ex GST
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ fontWeight: 'bold' }}
                  >
                    Total Ex GST
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceData?.invoiced_products_details?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align='center'>
                      {row.name ? row.name : '-'}
                    </TableCell>
                    <TableCell align='center'>
                      {row?.quantity?.unit ? row?.quantity?.unit : '-'}
                    </TableCell>
                    <TableCell align='center'>
                      {row?.quantity?.quantity_in_metric_ton
                        ? row?.quantity?.quantity_in_metric_ton
                        : '-'}
                    </TableCell>
                    <TableCell align='center'>
                      {row?.gst ? `${(row?.gst * 100).toFixed(0)} %` : '-'}
                    </TableCell>
                    <TableCell align='center'>
                      {row?.landing_price_ex_gst
                        ? `₹ ${row?.landing_price_ex_gst}`
                        : '-'}
                    </TableCell>
                    <TableCell align='center'>
                      {row?.sku_wise_discount
                        ? `₹ ${row?.sku_wise_discount}`
                        : '-'}
                    </TableCell>
                    <TableCell align='center'>
                      {row?.net_price_ex_gst
                        ? `₹ ${row?.net_price_ex_gst}`
                        : '-'}
                    </TableCell>
                    <TableCell align='center'>
                      {row?.total_ex_gst ? `₹ ${row?.total_ex_gst}` : '-'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack
            sx={{ mt: '2rem' }}
            direction={'row'}
            justifyContent={'flex-end'}
          >
            <Box>
              <Grid
                container
                spacing={2}
                sx={{ marginBottom: 2, display: 'block' }}
              >
                {invoiceData?.bill_info?.map((item, index) => (
                  <Grid
                    item
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography sx={{ fontWeight: 'bold' }}>
                      {item.display_name}
                    </Typography>
                    <Box m={2} />
                    <Typography>{item.label}</Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Stack>
        </Card>
        <Card sx={{ p: '2rem' }}>
          <Typography variant='h6'>Delivery Vechile Details</Typography>
          <Divider sx={{ mt: '1rem', mb: '3rem' }} />
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={6}
            >
              <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'space-between'}
                sx={{ pr: '3rem' }}
              >
                <Typography
                  variant='h6'
                  fontWeight={'550'}
                  fontSize={16}
                >
                  Vechile Driver Name :
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={'500'}
                  fontSize={16}
                >
                  {invoiceData?.delivery_vehicle_details?.vehicle_driver_name
                    ? invoiceData?.delivery_vehicle_details?.vehicle_driver_name
                    : '-'}
                </Typography>
              </Stack>
              <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'space-between'}
                sx={{ pr: '3rem' }}
              >
                <Typography
                  variant='h6'
                  fontWeight={'550'}
                  fontSize={16}
                >
                  Vechile Driver Phone Number :
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={'500'}
                  fontSize={16}
                >
                  {invoiceData?.delivery_vehicle_details
                    ?.vehicle_driver_phone_no
                    ? invoiceData?.delivery_vehicle_details
                        ?.vehicle_driver_phone_no
                    : '-'}
                </Typography>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'space-between'}
                sx={{ pr: '3rem' }}
              >
                <Typography
                  variant='h6'
                  fontWeight={'550'}
                  fontSize={16}
                >
                  Vechile Number :
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={'500'}
                  fontSize={16}
                >
                  {invoiceData?.delivery_vehicle_details?.vehicle_number
                    ? invoiceData?.delivery_vehicle_details?.vehicle_number
                    : '-'}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </>
  );
};

export default InvoiceDetailed;
